exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* --------------- Gallery --------------- */\n\n.gallery .album {\n\tmargin: 0;\n\tpadding: 30px 0 30px 0;\n\tbackground-color: transparent;\n}\n.gallery .album.even {\n\tbackground-color: #f2f3f5;\n}\n.gallery .album.odd.first {\n\tpadding: 0 0 30px 0;\n}\n.gallery .album .album-header {\n\twidth: 100%;\n\theight: 27px;\n\tmargin: 0 0 20px 0;\n\tpadding: 0;\n}\n.gallery .album .album-header h3.album-title {\n\tmargin: 0;\n\tpadding: 0;\n\tfloat: left;\n}\n.gallery .album .album-header small.album-description {\n\twidth: auto;\n\theight: 16px;\n\tmargin: 8px 0 2px 10px;\n\tpadding: 0;\n\tfloat: right;\n\tdisplay: inline-block;\n}\n.gallery .album .album-content .image {\n\tmargin: 0 0 30px 0;\n}\n.gallery .album .album-content .image img {\n\twidth: 100%;\n\theight: auto;\n\tmargin: 0;\n\tpadding: 0;\n\ttransition: all .2s ease;\n}\n.gallery .album .album-content .image img:hover,\n.gallery .album .album-content .image img:focus {\n\ttransform: scale(1.08);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/gallery/gallery.component.css
// module id = ./src/app/gallery/gallery.component.css
// module chunks = 1